import template from './coman-consent-manager-settings-icon.html.twig';
import './coman-consent-manager-settings-icon.scss';

const { Component } = Shopware;

Component.register('coman-consent-manager-settings-icon', {
    template,
    computed:{
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    }
});
